var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventBtnBgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 52,
    viewBox: "0 0 67 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5841 33.8131C18.9185 32.7017 21.535 30.0851 22.6465 26.7507L24.7779 20.3565C25.0279 19.6063 25.73 19.1003 26.5208 19.1003C27.3116 19.1003 28.0137 19.6063 28.2638 20.3565L30.3952 26.7507C31.5067 30.0851 34.1232 32.7017 37.4576 33.8131L43.8518 35.9445C44.602 36.1946 45.1081 36.8967 45.1081 37.6875C45.1081 38.4783 44.602 39.1804 43.8518 39.4305L37.4576 41.5619C34.1232 42.6733 31.5067 45.2899 30.3952 48.6243L28.2638 55.0185C28.0137 55.7687 27.3116 56.2747 26.5208 56.2747C25.73 56.2747 25.0279 55.7687 24.7779 55.0185L22.6465 48.6243C21.535 45.2898 18.9185 42.6733 15.584 41.5619L9.18984 39.4305C8.43962 39.1804 7.93359 38.4783 7.93359 37.6875C7.93359 36.8967 8.43962 36.1946 9.18984 35.9445L15.5841 33.8131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5777 15.5097C44.2964 14.9368 45.6451 13.5881 46.218 11.8693L47.1112 9.18984C47.3613 8.43962 48.0634 7.93359 48.8542 7.93359C49.645 7.93359 50.347 8.43962 50.5971 9.18984L51.4903 11.8693C52.0632 13.5881 53.4119 14.9368 55.1307 15.5097L57.8102 16.4029C58.5604 16.6529 59.0664 17.355 59.0664 18.1458C59.0664 18.9366 58.5604 19.6387 57.8102 19.8888L55.1307 20.7819C53.4119 21.3549 52.0632 22.7036 51.4903 24.4223L50.5971 27.1018C50.347 27.852 49.645 28.3581 48.8542 28.3581C48.0634 28.3581 47.3613 27.852 47.1112 27.1018L46.218 24.4223C45.6451 22.7036 44.2964 21.3549 42.5777 20.7819L39.8982 19.8888C39.148 19.6387 38.6419 18.9366 38.6419 18.1458C38.6419 17.355 39.148 16.6529 39.8982 16.4029L42.5777 15.5097Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventBtnBgStar);
export default __webpack_public_path__ + "static/media/event-btn-bg-star.6f607e23974bfd97fd6fbcdc77033bb9.svg";
export { ForwardRef as ReactComponent };